// extracted by mini-css-extract-plugin
module.exports = {"appBackground":"main_appBackground__3Z46U","main":"main_main__9iBQI"};